import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const getStudentPurchasenRequests = createAsyncThunk(
  "purchaseRequest/getStudentPurchasenRequests",
  async ({ search, skip, limit, status, course_id }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
        params: {
          search,
          skip,
          limit,
          status,
          course_id
        }
      };

      const response = await axios.get(
        `${BASE_URL}/course-purchase-requests`,
        config
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (err) {
      if (err.message === "Network Error") {
        return rejectWithValue({
          message: "Network Error",
          status: 404,
          statusText: err.code,
        });
      } else {
        return rejectWithValue(err.response?.data || "Unknown error occurred");
      }
    }
  }
);

export const getPurchaseRequestById = createAsyncThunk(
  "purchaseRequest/getPurchaseRequestById",
  async ({ id }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      };

      const response = await axios.get(
        `${BASE_URL}/course-purchase-requests/${id}`,
        config
      );

      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (err) {
      if (err.message === "Network Error") {
        return rejectWithValue({
          message: "Network Error",
          status: 404,
          statusText: err.code,
        });
      } else {
        return rejectWithValue(err.response?.data || "Unknown error occurred");
      }
    }
  }
);

export const approveOrRejectPurchaseRequest = createAsyncThunk(
  "purchaseRequest/approveOrRejectPurchaseRequest",
  async (formData, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      };

      const body = JSON.stringify(formData);

      const response = await axios.put(
        `${BASE_URL}/course-purchase-requests/approve-or-reject`,
        body,
        config
      );

      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (err) {
      if (err.message === "Network Error") {
        return rejectWithValue({
          message: "Network Error",
          status: 404,
          statusText: err.code,
        });
      } else {
        return rejectWithValue(err.response?.data || "Unknown error occurred");
      }
    }
  }
);

export const clearPurchaseRequestMessage = () => ({
  type: 'purchaseRequest/clearPurchaseMessage',
});